import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer bg-transparent" style={{ zIndex: '-1' }}>
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-block ">
                                {new Date().getFullYear()} © Nextira.
                            </div>
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block ">
                                Design & Develop by NEXTIRA
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;